import {Injectable} from '@angular/core';
import {Plugins} from '@capacitor/core';

const {Storage} = Plugins;

@Injectable({
  providedIn: 'root'
})
export class StorageService {


  constructor() {

  }

  removeValueInStorage(key) {
    return Storage.remove({key});
  }


  saveToStorage(key, value: string) {
    return Storage.set({key, value});
  }

  getStorage(key) {
    return Storage.get({key});
  }

  

  getStorageSync(key) {
    return new Promise((resolve, reject) => {
      Storage.get({ key })
        .then(bl => {
          resolve(bl.value);
        })
        .catch(reject);
    });
  }

  async emptyStorage() {
    return Storage.clear();
  }


}
